import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import * as LucideIcons from 'lucide-react';

const GrievanceStepCard = ({ step, onEdit, onDelete }) => {
    // Dynamically get the icon component from Lucide
    const IconComponent = LucideIcons[step.icon] || LucideIcons.HelpCircle;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className="h-2 bg-gradient-to-r from-blue-500 to-indigo-600"></div>

            <div className="p-5">
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <div className="p-3 rounded-xl bg-blue-50 text-blue-600 shadow-sm">
                            <IconComponent className="h-6 w-6" />
                        </div>
                        <div>
                            <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">Step {step.step_number}</span>
                            <h3 className="font-bold text-slate-800 line-clamp-1" title={step.title}>{step.title}</h3>
                        </div>
                    </div>

                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(step)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(step.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-3">
                    <p className="text-slate-600 text-sm leading-relaxed line-clamp-2" title={step.description}>
                        {step.description}
                    </p>

                    <div className="flex items-center gap-2 text-sm text-slate-500 bg-slate-50 p-2 rounded-lg">
                        <LucideIcons.Clock className="w-4 h-4" />
                        <span>{step.timeline}</span>
                    </div>

                    <div className="flex items-center justify-between pt-2 border-t border-slate-100">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${step.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {step.is_active ? 'Active' : 'Inactive'}
                        </span>
                        <span className="text-[10px] font-bold text-slate-400">ORDER #{step.display_order}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GrievanceStepCard;
